import {PrimaryModels, StyleteqState} from "../_definitions/styleteq";
import {createSelector} from "reselect";
import {Map} from "immutable";
import * as pluralize from "pluralize";
import User from "./models/User";
import Shop from "./models/Shop";
import Booth from "./models/Booth";
import Style from "./models/Style";
import Special from "./models/Special";
import Conversation from "./models/Conversation";
import Message from "./models/Message";

export const dataSelector = (state: StyleteqState) => state.data;
export const dataByResourceNameSelector = (state: StyleteqState, resource: string) =>
    state.data[pluralize(resource)] as Map<number, PrimaryModels>;

//Users
export const usersSelector = (state: StyleteqState) => dataSelector(state).users;
export const userByIdSelector = (state: StyleteqState, id: number) => dataByIdSelector<User>(state, id, usersSelector);

//Shops
export const shopsSelector = (state: StyleteqState) => dataSelector(state).shops;
export const shopByIdSelector = (state: StyleteqState, id: number) => dataByIdSelector<Shop>(state, id, shopsSelector);

//Booths
export const boothsSelector = (state: StyleteqState) => dataSelector(state).booths;
export const boothByIdSelector = (state: StyleteqState, id: number) => dataByIdSelector<Booth>(state, id, boothsSelector);

//Styles
export const stylesSelector = (state: StyleteqState) => dataSelector(state).styles;
export const styleByIdSelector = (state: StyleteqState, id: number) => dataByIdSelector<Style>(state, id, stylesSelector);

//Specials
export const specialsSelector = (state: StyleteqState) => dataSelector(state).specials;
export const specialByIdSelector = (state: StyleteqState, id: number) => dataByIdSelector<Special>(state, id, specialsSelector);

//Conversations
export const conversationsSelector = (state: StyleteqState) => dataSelector(state).conversations;
export const conversationByIdSelector = (state: StyleteqState, id: number) => dataByIdSelector<Conversation>(state, id, conversationsSelector);
export const conversationByIdsSelector = (state: StyleteqState, ids: number[]) => createSelector(
    conversationsSelector,
    (specials: Map<number, Conversation>) => ids.map(id=>specials.get(id))
)(state);

//Messages
export const messagesSelector = (state: StyleteqState) => dataSelector(state).messages;
export const messageByIdSelector = (state: StyleteqState, id: number) => dataByIdSelector<Message>(state, id, messagesSelector);
export const messageByIdsSelector = (state: StyleteqState, ids: number[]) => createSelector(
    messagesSelector,
    (specials: Map<number, Message>) => ids.map(id=>specials.get(id))
)(state);


//Helpers
function dataByIdSelector<T>(state: StyleteqState, id: number, selector) {
    return createSelector(
        selector,
        (specials: Map<number, T>) => specials.get(id)
    )(state);
}



// WEBPACK FOOTER //
// ./app/client/_data/selectors.ts